import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { LoadingSpinner } from "@web/components/LoadingSpinner";
import { Navbar } from "@web/components/Navbar";
import { ProfileForm } from "@web/components/ProfileForm";
import { useAppContext } from "@web/route-services/root/AppContext";
import { Sidepane } from "@web/route-services/settings/Sidepane";
import { motion } from "motion/react";

export const Route = createFileRoute("/settings/profile")({
  component: ProfilePage
});

function ProfilePage() {
  const { isDesktopScreen } = useAppContext();

  if (isDesktopScreen) {
    return (
      <div className="from-background-gradient via-background to-background text-tx-secondary flex h-screen w-screen bg-gradient-to-b text-sm antialiased antialiased">
        <Navbar />
        <div style={{ scrollbarGutter: "stable" }} className="scroll-home-page flex w-full flex-row overflow-auto py-4">
          <Sidepane />
          <SettingsCard />
        </div>
      </div>
    );
  }

  return (
    <>
      <Navbar />
      <SettingsCard />
    </>
  );
}

interface SettingsCardProps {}

function SettingsCard({}: SettingsCardProps) {
  const { access, isDesktopScreen } = useAppContext();

  const {
    data: profile,
    error,
    isPending,
    isError
  } = useQuery({
    queryKey: ["profileSelf"],
    queryFn: async () => {
      return await access.profile.getSelf();
    }
  });

  return (
    <motion.div
      className="mt-20 flex h-full w-full flex-col items-center justify-center space-y-5 pb-20 md:mt-0 md:px-8 md:pb-0"
      initial={{ opacity: 0, scale: 0.98 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0 }}
      transition={{
        duration: 0.2,
        ease: [0, 0.71, 0.2, 1.01]
      }}
    >
      <h1 className="text-tx-primary text-2xl font-bold tracking-wide">Profile Settings</h1>
      <div className="border-line bg-container-primary flex h-fit w-full items-center justify-center rounded-2xl border md:h-[42rem] md:w-[32rem] ">
        {isPending ? (
          <LoadingSpinner />
        ) : isError ? (
          <div className="flex h-full items-center justify-center">
            <span>Error: {error.message}</span>
          </div>
        ) : profile ? (
          <ProfileForm profile={profile} />
        ) : (
          <div className="flex h-full items-center justify-center">
            <span>No profile data available</span>
          </div>
        )}
      </div>
    </motion.div>
  );
}
